"use strict";
var base = require("./base");

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            if ($(".product-detail > .bundle-items").length) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else if ($(".product-set-detail").eq(0).length) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not(.bundle-item)").data("pid", response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            // update local add to cart (for sets)
            $("button.add-to-cart", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));

            var enable = $(".product-availability").toArray().every(function (item) {
                return $(item).data("available") && $(item).data("ready-to-order");
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $(".size-chart a").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var $prodSizeChart = $(this).closest(".size-chart").find(".size-chart-collapsible");
            if ($prodSizeChart.is(":empty")) {
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json",
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass("active");
        });

        var $sizeChart = $(".size-chart-collapsible");
        $("body").on("click touchstart", function (e) {
            if ($(".size-chart").has(e.target).length <= 0) {
                $sizeChart.removeClass("active");
            }
        });
    },
    copyProductLink: function () {
        $("body").on("click", "#fa-link", function (event) { // Add event parameter
            event.preventDefault();
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#shareUrl").val()).select();
            document.execCommand("copy");
            $temp.remove();
            $(".copy-link-message").attr("role", "alert");
            $(".copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    },

    productVariantSelector: function () {
        var activePriceRefreshRequest = null;
        var latestPriceRefreshId = 0;

        function hasRenderablePrice() {
            var priceText = $(".product-details-section").first().find(".prices").first().text().replace(/\s/g, "");
            return /\d/.test(priceText);
        }

        function ensureQuantityParam(url) {
            if (!url) {
                return url;
            }

            try {
                var parsedUrl = new URL(url, window.location.origin);
                if (!parsedUrl.searchParams.get("quantity")) {
                    parsedUrl.searchParams.set("quantity", $(".quantity-select").first().val() || 1);
                }
                return parsedUrl.toString();
            } catch (error) {
                return url;
            }
        }

        function applyVariantColorStyles($scope) {
            var $context = $scope && $scope.length ? $scope : $(document);
            $context.find("[data-product-variant-color-code]").each(function () {
                var colorCode = ($(this).data("product-variant-color-code") || "").toString().trim();
                if (colorCode) {
                    $(this).css("background-color", colorCode);
                }
            });

            $context.find(".product-custom-variants__dropdown-option").each(function () {
                var optionColorCode = ($(this).data("product-variant-option-color-code") || "").toString().trim();
                var $dot = $(this).find(".product-custom-variants__dropdown-option-dot");

                if (optionColorCode) {
                    $dot.css("background-color", optionColorCode).addClass("is-visible");
                } else {
                    $dot.css("background-color", "").removeClass("is-visible");
                }
            });
        }

        function updatePdpPriceSection(showUrl) {
            latestPriceRefreshId += 1;
            var refreshId = latestPriceRefreshId;

            if (activePriceRefreshRequest && activePriceRefreshRequest.readyState !== 4) {
                activePriceRefreshRequest.abort();
            }

            activePriceRefreshRequest = $.ajax({
                url: showUrl,
                method: "GET"
            }).done(function (html) {
                if (refreshId !== latestPriceRefreshId) {
                    return;
                }

                var $newPage = $("<div>").append($.parseHTML(html));
                var $currentPriceElement = $(".product-details-section").first().find(".prices").first();
                var $newPriceElement = $newPage.find(".product-details-section .prices").first();

                if (!$newPriceElement.length) {
                    $newPriceElement = $newPage.find(".prices").first();
                }

                if ($currentPriceElement.length && $newPriceElement.length) {
                    $currentPriceElement.replaceWith($newPriceElement);
                }

                if (!hasRenderablePrice() && showUrl) {
                    window.location.href = showUrl;
                }
            }).fail(function (jqXHR, textStatus) {
                if (textStatus === "abort" || refreshId !== latestPriceRefreshId) {
                    return;
                }
                if (showUrl) {
                    window.location.href = showUrl;
                }
            });
        }

        function updateCustomVariantVisualState(selectedUrl) {
            if (!selectedUrl) {
                return;
            }

            $(".product-custom-variants__swatch").removeClass("selected");
            $(".product-custom-variants__swatch[data-product-variant-url=\"" + selectedUrl + "\"]")
                .addClass("selected");
        }

        function selectProductVariant(showUrl, variationUrl, optionLabel, optionColorCode) {
            if (!showUrl) {
                return;
            }
            var $productContainer = $(".product-detail:not(\".bundle-item\")").first();

            if (!$productContainer.length || !variationUrl) {
                window.location.href = showUrl;
                return;
            }

            var variationUrlWithQuantity = ensureQuantityParam(variationUrl);

            var didUpdateViaAjax = false;
            $("body").one("product:afterAttributeSelect.customVariantSelector", function (event, payload) {
                didUpdateViaAjax = true;
                updateCustomVariantVisualState(showUrl);
                history.replaceState({}, "", showUrl);

                if (optionLabel) {
                    $(".product-custom-variants [data-product-variant-dropdown-label]").first().text(optionLabel);
                }

                if (typeof optionColorCode !== "undefined") {
                    updateSelectedVariantColorDot($(".product-custom-variants").first(), optionColorCode);
                }

                var responseProduct = payload && payload.data && payload.data.product
                    ? payload.data.product
                    : null;
                if (responseProduct && responseProduct.productName) {
                    $(".product-name").text(responseProduct.productName);
                }

                updatePdpPriceSection(showUrl);
            });

            base.attributeSelect(variationUrlWithQuantity, $productContainer);

            setTimeout(function () {
                if (!didUpdateViaAjax) {
                    window.location.href = showUrl;
                }
            }, 4000);
        }

        function updateSelectedVariantColorDot($container, selectedColorCode) {
            var colorCode = (selectedColorCode || "").toString().trim();
            var $selectedDot = $container.find("[data-product-variant-selected-dot]").first();

            if (!$selectedDot.length) return;

            if (colorCode) {
                $selectedDot.css("background-color", colorCode).addClass("is-visible");
                return;
            }

            $selectedDot.css("background-color", "").removeClass("is-visible");
        }

        applyVariantColorStyles($(".product-custom-variants"));

        $("[data-product-variant-dropdown]").each(function () {
            var $dropdown = $(this);
            var $selectedOption = $dropdown.find(".product-custom-variants__dropdown-option.selected").first();

            if ($selectedOption.length) {
                var selectedColorCode = $selectedOption.data("product-variant-option-color-code");
                updateSelectedVariantColorDot($dropdown, selectedColorCode);
            }

            applyVariantColorStyles($dropdown);
        });

        $("body").on("click", ".product-custom-variants__swatch[data-product-variant-url]", function () {
            var variantUrl = $(this).data("product-variant-url");
            if (variantUrl) {
                selectProductVariant(
                    variantUrl,
                    ($(this).data("product-variant-variation-url") || "").toString(),
                    ($(this).attr("aria-label") || "").toString(),
                    ($(this).data("product-variant-color-code") || "").toString()
                );
            }
        });

        $("body").on("click", "[data-product-variant-dropdown-trigger]", function (event) {
            event.preventDefault();
            event.stopPropagation();

            var $trigger = $(this);
            var $dropdown = $trigger.closest("[data-product-variant-dropdown]");
            var isOpen = $dropdown.hasClass("is-open");

            $("[data-product-variant-dropdown]").removeClass("is-open");
            $("[data-product-variant-dropdown-trigger]").attr("aria-expanded", "false");

            if (!isOpen) {
                $dropdown.addClass("is-open");
                $trigger.attr("aria-expanded", "true");
            }
        });

        $("body").on("click", ".product-custom-variants__dropdown-option", function () {
            var $option = $(this);
            var $dropdown = $option.closest("[data-product-variant-dropdown]");
            var $selectorContainer = $option.closest("[data-product-variant-selector]");
            var optionLabel = ($option.data("product-variant-option-label") || "").toString();
            var optionColorCode = ($option.data("product-variant-option-color-code") || "").toString();
            var url = $option.data("product-variant-url");
            var variationUrl = ($option.data("product-variant-variation-url") || "").toString();

            $dropdown.find(".product-custom-variants__dropdown-option").removeClass("selected");
            $option.addClass("selected");
            $dropdown.find("[data-product-variant-dropdown-label]").text(optionLabel);
            updateSelectedVariantColorDot($selectorContainer, optionColorCode);
            $dropdown.removeClass("is-open");
            $dropdown.find("[data-product-variant-dropdown-trigger]").attr("aria-expanded", "false");

            if (url) {
                selectProductVariant(url, variationUrl, optionLabel, optionColorCode);
            }
        });

        $("body").on("click", function () {
            $("[data-product-variant-dropdown]").removeClass("is-open");
            $("[data-product-variant-dropdown-trigger]").attr("aria-expanded", "false");
        });

        $("body").on("click", "[data-product-variant-toggle-swatches]", function () {
            var $toggleButton = $(this);
            var $swatchesContainer = $toggleButton
                .closest("[data-product-variant-selector]")
                .find("[data-product-variant-swatches]")
                .first();

            if (!$swatchesContainer.length) {
                return;
            }

            $swatchesContainer.toggleClass("is-expanded");
            var expandLabel = $toggleButton.data("label-expand") || "Ver Todas";
            var collapseLabel = $toggleButton.data("label-collapse") || "Ver Menos";
            $toggleButton.text($swatchesContainer.hasClass("is-expanded") ? collapseLabel : expandLabel);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    pdpZoom: function () {
        const $swiperContainer = $(".image-carrousel__primary .swiper");
        if (!$swiperContainer.length || window.innerWidth <= 768) return; // Only desktop

        function preloadZoomImage($img) {
            if ($img.data("zoom-preloaded")) return;
            const zoomSrc = $img.attr("data-zoom-src");
            if (zoomSrc) {
                const preloadImg = new window.Image();
                preloadImg.src = zoomSrc;
                $img.data("zoom-preloaded", true);
            }
        }

        var $zoomImgs = $swiperContainer.find("img[data-zoom-src]");
        if ($zoomImgs.length > 0) {
            preloadZoomImage($zoomImgs.eq(0));
        }

        $swiperContainer.on("transitionend", function () {
            var $activeImg = $swiperContainer.find(".swiper-slide-active img[data-zoom-src]");
            if ($activeImg.length && !$activeImg.data("zoom-preloaded")) {
                setTimeout(function () {
                    preloadZoomImage($activeImg);
                }, 300);
            }
        });

        function getActiveImage() {
            const $activeSlide = $swiperContainer.find(".swiper-slide-active");
            return $activeSlide.length ? $activeSlide.find("img") : null;
        }

        function applyZoomSrc($img) {
            const zoomSrc = $img.attr("data-zoom-src");
            if (zoomSrc && zoomSrc.trim() !== "" && $img.attr("src") !== zoomSrc) {
                if (!$img.data("original-src")) {
                    $img.data("original-src", $img.attr("src"));
                }
                $img.attr("src", zoomSrc);
            }
        }

        $swiperContainer.on("mouseenter", function () {
            const $img = getActiveImage();
            if ($img && $img.length) {
                applyZoomSrc($img);
            }
        });

        $swiperContainer.on("mousemove", function (e) {
            const $img = getActiveImage();
            if (!$img || !$img.length) return;

            const offset = $swiperContainer.offset();
            const x = ((e.pageX - offset.left) / $swiperContainer.width()) * 100;
            const y = ((e.pageY - offset.top) / $swiperContainer.height()) * 100;

            $img.css({
                "transition": "transform 0.1s ease-out",
                "transform-origin": `${x}% ${y}%`,
                "transform": "scale(1.6)"
            });
        });

        $swiperContainer.on("mouseleave click", function () {
            const $img = getActiveImage();
            if ($img && $img.length) {
                $img.css({
                    "transition": "transform 0.3s ease",
                    "transform": "scale(1)",
                    "transform-origin": "center center"
                });
            }
        });
    },
};


let observer = new MutationObserver(() => {
    let descriptionContainer = document.querySelector("#product-description-content");
    if (descriptionContainer) {
        observer.disconnect();
        initShowMore();
    }
});

let observer2 = new MutationObserver(() => {
    let descriptionContainerMobile = document.querySelector("#product-details");
    if (descriptionContainerMobile) {
        observer2.disconnect();
        initShowMoreMobile();
    }
});

observer.observe(document.body, { childList: true, subtree: true });
observer2.observe(document.body, { childList: true, subtree: true });

function initShowMore() {
    let descriptionContainer = document.querySelector("#product-description-content");
    let showMoreLink = document.querySelector(".show-more");

    if (!descriptionContainer || !showMoreLink) return;

    let fullText = descriptionContainer.textContent.trim();
    let maxChars = 500;

    if (fullText.length > maxChars) {
        let truncatedText = `<br><p>${fullText.substring(0, maxChars).trim() + "..."}</p>`;
        descriptionContainer.setAttribute("data-full-text", descriptionContainer.innerHTML);
        descriptionContainer.setAttribute("data-truncated-text", truncatedText);
        descriptionContainer.innerHTML = truncatedText;

        showMoreLink.style.display = "inline";
    }

    showMoreLink.addEventListener("click", function (event) {
        event.preventDefault();

        if (descriptionContainer.classList.contains("full-text")) {
            descriptionContainer.innerHTML = descriptionContainer.getAttribute("data-truncated-text");
            descriptionContainer.classList.remove("full-text");
            showMoreLink.textContent = "Mostrar Más";
            const posicao = this.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: posicao - 500, // scroll 500px acima do mostrar mais
                behavior: "smooth"
            });

        } else {
            descriptionContainer.innerHTML = descriptionContainer.getAttribute("data-full-text");
            descriptionContainer.classList.add("full-text");
            showMoreLink.textContent = "Mostrar Menos";
        }
    });
}

function initShowMoreMobile() {
    const toggleBtn = document.querySelector("[data-toggle=\"collapse\"], [data-bs-toggle=\"collapse\"]");
    const descriptionContainer = document.getElementById("product-details");
    const showMoreLink = document.getElementById("show-more-mobile");

    if (!toggleBtn || !descriptionContainer || !showMoreLink) return;
    
    let fullText = descriptionContainer.children[0].textContent.trim();
    let maxChars = 500;

    if (fullText.length > maxChars) {
        let truncatedText = `<br><p>${fullText.substring(0, maxChars).trim() + "..."}</p>`;
        descriptionContainer.children[0].setAttribute("data-full-text", descriptionContainer.innerHTML);
        descriptionContainer.children[0].setAttribute("data-truncated-text", truncatedText);
        descriptionContainer.children[0].innerHTML = truncatedText;
        showMoreLink.style.display = "inline";
    }

    showMoreLink.addEventListener("click", function (event) {
        event.preventDefault();

        if (descriptionContainer.children[0].classList.contains("full-text")) {
            descriptionContainer.children[0].innerHTML = descriptionContainer.children[0].getAttribute("data-truncated-text");
            descriptionContainer.children[0].classList.remove("full-text");
            showMoreLink.textContent = "Mostrar Más";
            const posicao = this.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: posicao - 300,
                behavior: "smooth"
            });
        } else {
            descriptionContainer.children[0].innerHTML = descriptionContainer.children[0].getAttribute("data-full-text");
            descriptionContainer.children[0].classList.add("full-text");
            showMoreLink.textContent = "Mostrar Menos";
        }
    });
}
